import Flickity from "flickity";

class Brands {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-brands="scope"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let observer = new ResizeObserver(this.onResize.bind(this));
			observer.observe(scope);
		});
	}

	onResize(entries) {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let scope = entries[0].target;
			let flickity = Flickity.data(scope);
			let width = $(window).width();
			if(width < 768 && flickity.options.cellAlign === 'right') {
				flickity.options.cellAlign = 'left';
				flickity.resize();
			} else if(width >= 768 && flickity.options.cellAlign === 'left') {
				flickity.options.cellAlign = 'right';
				flickity.resize();
			}
		}, 200);
	}
}

export default new Brands;